import { render, staticRenderFns } from "./newReceive.vue?vue&type=template&id=702f696e&"
import script from "./newReceive.vue?vue&type=script&lang=js&"
export * from "./newReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports